<template>
  <div class="footer">
    <div class="footernew">
      <div class="footerbox fbox1">
        <h3>主办单位</h3>
        <p>中国国际贸易促进委员会</p>
        <p>山东省人民政府</p>
        <h3>承办单位</h3>
        <p>中国国际贸易促进委员会山东省委员会</p>
        <p>东营市人民政府</p>
      </div>
      <div class="footerbox fbox2">
        <h3>联系方式</h3>
        <p>观众咨询：0546-7799222</p>
        <p>展商咨询：0546-7797755</p>
        <p>综合事务咨询：0546-7799666</p>
        <h3></h3>
        <h3></h3>
        <p>chinagrtyre@grtirexpo.com</p>
        <p>山东省广饶县乐安大街997号广饶国际博览中心</p>
      </div>
      <div class="footerbox fbox3">
        <img
          src="//www.chinagrtae.com/webfile/images1/bottomLogo.png"
          width="100%"
          alt=""
        />
        <h3 style="text-align: center">轮胎之都&nbsp;&nbsp;中国广饶</h3>
        <h6 style="text-align: left">
          <a
            href="https://beian.miit.gov.cn"
            style="color: #5a646c; font-weight: normal; text-decoration: none"
            >Copyright © 2022 | 鲁ICP备15027171号-1</a
          >
        </h6>
      </div>
      <div class="footerbox fbox4">
        <h3>微信公众号</h3>
        <div class="footerbox fboxn1">
          <img src="//www.chinagrtae.com/webfile/images1/erweima.jpg" />
          <p>扫码关注官网微信公众号 了解更多展会资讯</p>
        </div>
      </div>
    </div>
  </div>
  <div class="footerPC">
    <div class="footernew">
      <div class="footerbox fnbox1">
        <img src="//www.chinagrtae.com/webfile/images1/bottomLogo.png" />
        <h3>轮胎之都&nbsp;&nbsp;中国广饶</h3>
        <h6>
          <a href="https://beian.miit.gov.cn" style="color: #5a646c"
            >Copyright © 2022 | 鲁ICP备15027171号-1</a
          >
        </h6>
      </div>
      <div class="footerbox fnbox2"></div>
      <div class="footerbox fnbox3">
        <h3>联系方式</h3>
        <p>观众咨询：0546-7799222</p>
        <p>展商咨询：0546-7797755</p>
        <p>综合事务咨询：0546-7799666</p>
        <h3></h3>
        <h3></h3>
        <p>chinagrtyre@grtirexpo.com</p>
        <p>山东省广饶县乐安大街997号广饶国际博览中心</p>
      </div>
      <div class="footerbox fnbox4">
        <h3>微信公众号</h3>
        <p></p>
        <div class="footerbox fnboxn1">
          <img src="//www.chinagrtae.com/webfile/images1/erweima.jpg" />
          <p>扫码关注官网微信公众号 了解更多展会资讯</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="less">
.footerPC {
  display: none;
}
.footer {
  width: 100%;
  overflow: hidden;
  padding: 30px 0;
  background: #dcebf5;
  .footernew {
    width: 98%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    .footerbox {
      text-align: left;
      h3 {
        font-weight: bold;
        font-size: 18px;
        color: #5a646c;
        margin: 20px 0 10px 0;
      }
      p {
        font-size: 12px;
        color: #5a646c;
        margin: 0 0 10px;
      }
    }
    .fbox1 {
      width: 45%;
      color: #5a646c;
      padding: 0 3%;
    }
    .fbox2 {
      width: 55%;
      color: #5a646c;
      padding: 0 0 0 3%;
    }
    .fbox3 {
      width: 45%;
      padding: 3% 0;
      margin-right: 5%;
    }
    .fbox4 {
      width: 48%;
      color: #5a646c;
      padding: 0 3%;
      h3 {
        text-align: center;
        font-size: 14px;
        margin: 0 0 1rem 0;
      }
      .fboxn1 {
        width: 100%;
        text-align: center;
        img {
          width: 70%;
        }
        p {
          width: 100%;
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .footer {
    display: none;
  }
  .footerPC {
    width: 100%;
    overflow: hidden;
    padding: 50px 0;
    background: #dcebf5;
    display: block;
    .footernew {
      width: 65%;
      margin: 0 auto;
      overflow: hidden;
      .footerbox {
        text-align: left;
        h3 {
          margin-top: 20px;
          margin-bottom: 10px;
          font-weight: bold;
          font-size: 18px;
          color: #5a646c;
        }
        p {
          font-size: 12px;
          color: #5a646c;
          margin: 0 0 10px;
        }
      }
      .fnbox1 {
        float: left;
        width: 28%;
        padding: 0 3% 0 0;
        > img {
          margin-top: 20px;
          width: 80%;
        }
      }
      .fnbox2 {
        float: left;
        width: 25%;
        color: #5a646c;
        border-left: 1px solid #d5e1e9;
        border-right: 1px solid #d5e1e9;
        padding: 0 3%;
      }
      .fnbox3 {
        float: left;
        width: 25%;
        color: #5a646c;
        border-right: 1px solid #d5e1e9;
        padding: 0 3%;
      }
      .fnbox4 {
        float: left;
        width: 20%;
        color: #5a646c;
        padding: 0 3%;
        .fnboxn1 {
          width: 100%;
          > img {
            width: 100%;
          }
          > p {
            width: 100%;
            text-align: center;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>